"use strict";

import getContext from "./getContext";
import cookie from "./cookie";

const hostProvider = (function(){
	
	let isChromeApp = getContext() == "chromeapp";
	
	function get(callback){
		
		callback = callback || (host => {});
		
		return new Promise(resolve => {
			
			if(isChromeApp){
				chrome.storage.local.get("host", function(result){

					if(Object.keys(result).length != 0){
						callback(result.host);
						resolve(result.host);
					}
					else{
						callback(null);
						resolve(null)
					}

				});
			}
			else {
				const host = cookie.get('host');
				callback(host || window.location.host);
				resolve(host || window.location.host);
			}
		});
	}

	function set(host){
		return new Promise(resolve => {
			if(isChromeApp){
				chrome.storage.local.set({host: host}, resolve);
			}
			else{
				cookie.set('host', host, {path: '/', expires : 30});
			}
		});
	}

	function remove(){
		if(isChromeApp){
			chrome.storage.local.remove("host");
		}
		else{
			cookie.clear('host', {path: '/'});
		}
	}

	return {
		get: get,
		set: set,
		remove: remove
	};

})();

window.host = hostProvider;

export default hostProvider;


// WEBPACK FOOTER //
// ./~/vwa/host.js